import type { ComponentProps } from 'react'

import { ICON_DEFAULT_COLOR, ICON_DEFAULT_FILL, type IconProps } from 'components'

export const SpainFlag = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = '24', // TODO: Replace with ICON_DEFAULT_WIDTH when migration to ION is complete
  height = '24', // TODO: Replace with ICON_DEFAULT_HEIGHT when migration to ION is complete
  viewBox = '0 0 24 24', // TODO: Replace with ICON_DEFAULT_VIEWBOX when migration to ION is complete
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23 17.5385C23 18.1913 22.7425 18.8174 22.284 19.279C21.8256 19.7407 21.2039 20 20.5556 20H3.44444C2.79614 20 2.17438 19.7407 1.71596 19.279C1.25754 18.8174 1 18.1913 1 17.5385V6.46154C1 5.8087 1.25754 5.1826 1.71596 4.72097C2.17438 4.25934 2.79614 4 3.44444 4H20.5556C21.2039 4 21.8256 4.25934 22.284 4.72097C22.7425 5.1826 23 5.8087 23 6.46154V17.5385Z"
        fill="#C60A1D"
      />
      <path d="M1 8.30769H23V15.6923H1V8.30769Z" fill="#FFC400" />
      <path
        d="M6.5 11.3846V13.2308C6.5 13.7204 6.69315 14.19 7.03697 14.5362C7.38079 14.8824 7.8471 15.0769 8.33333 15.0769C8.81956 15.0769 9.28588 14.8824 9.6297 14.5362C9.97351 14.19 10.1667 13.7204 10.1667 13.2308V11.3846H6.5Z"
        fill="#EA596E"
      />
      <path d="M8.33333 10.7692H10.1667V12.6154H8.33333V10.7692Z" fill="#F4A2B2" />
      <path d="M6.5 10.7692H8.33333V12.6154H6.5V10.7692Z" fill="#DD2E44" />
      <path
        d="M8.33333 10.7692C9.34586 10.7692 10.1667 10.356 10.1667 9.84615C10.1667 9.33635 9.34586 8.92308 8.33333 8.92308C7.32081 8.92308 6.5 9.33635 6.5 9.84615C6.5 10.356 7.32081 10.7692 8.33333 10.7692Z"
        fill="#EA596E"
      />
      <path
        d="M8.33333 9.84615C9.34586 9.84615 10.1667 9.63952 10.1667 9.38462C10.1667 9.12971 9.34586 8.92308 8.33333 8.92308C7.32081 8.92308 6.5 9.12971 6.5 9.38462C6.5 9.63952 7.32081 9.84615 8.33333 9.84615Z"
        fill="#FFAC33"
      />
      <path
        d="M5.27778 10.7692H5.88889V15.0769H5.27778V10.7692ZM10.7778 10.7692H11.3889V15.0769H10.7778V10.7692Z"
        fill="#99AAB5"
      />
      <path
        d="M4.66667 14.4615H6.5V15.0769H4.66667V14.4615ZM10.1667 14.4615H12V15.0769H10.1667V14.4615ZM5.27778 10.1538H5.88889L5.88889 10.7692H5.27778V10.1538ZM10.7778 10.1538H11.3889L11.3889 10.7692H10.7778V10.1538Z"
        fill="#66757F"
      />
    </svg>
  )
}
